import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import "jquery-match-height/jquery.matchHeight";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import "@fortawesome/fontawesome-free/js/fontawesome.min";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/regular.min";
import "@fortawesome/fontawesome-free/js/brands.min";

import {animations} from "./animations";
import {initHeroSlider} from "./sliders";
import {initProductSlider} from "./sliders";
import {initBrandsSlider} from "./sliders";
import {initSingleProductSlider} from "./sliders";
import { initFreeScrollSlider } from './sliders';


/****************************************************************************
 * Theme scripts.
 ****************************************************************************/


window.addEventListener('load', function() {
    AOS.refresh();
});

window.onload = function() {
    document.body.classList.add('is-ready');
};

document.addEventListener('DOMContentLoaded', function() {
    AOS.init();
    initHeroSlider();
    initProductSlider();
    initBrandsSlider();
    initSingleProductSlider();
    initFreeScrollSlider();

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            items: {
                close: {
                    type: "close",
                },
            },
        },
        thumbs: {
            autoStart: false, // ensure thumbs don't auto-show
        },
        // Disable all other plugins if you're not using them
        Carousel: {
            Navigation: false,
        },
    });

    document.querySelectorAll('.js-custom-video').forEach(wrapper => {
        const playBtn = wrapper.querySelector('.custom-play-button');
        const videoSrc = wrapper.getAttribute('data-video-src');

        playBtn.addEventListener('click', function () {
            const video = document.createElement('video');
            video.src = videoSrc;
            video.setAttribute('controls', true);
            video.setAttribute('playsinline', true);
            video.setAttribute('autoplay', true);
            wrapper.innerHTML = '<hr class="spacer">';
            wrapper.appendChild(video);
            video.play();
        });
    });

    //Popup

    // Open popup
    document.querySelectorAll('.js-trigger-popup').forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            const popup = document.querySelector('.popup'); // or use data-popup-id if you want multiple
            if (popup) {
                popup.classList.add('is-visible');
                document.body.classList.add('popup-open'); // optional: lock scroll
            }
        });
    });

    // Close popup
    document.querySelectorAll('.js-close-popup').forEach(closeBtn => {
        closeBtn.addEventListener('click', function () {
            const popup = this.closest('.popup');
            if (popup) {
                popup.classList.remove('is-visible');
                document.body.classList.remove('popup-open');
            }
        });
    });

    // Optional: Close on background click
    document.querySelectorAll('.popup').forEach(popup => {
        popup.addEventListener('click', function (e) {
            if (e.target === popup) {
                popup.classList.remove('is-visible');
                document.body.classList.remove('popup-open');
            }
        });
    });

    // Optional: Close with ESC key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            document.querySelectorAll('.popup.is-visible').forEach(popup => {
                popup.classList.remove('is-visible');
                document.body.classList.remove('popup-open');
            });
        }
    });

    jQuery(document).ready(function($) {
        function getUrlParam(name) {
            const url = new URL(window.location.href);
            return url.searchParams.get(name);
        }

        function setViewClass(view) {
            if (view === 'grid' || view === 'list') {
                $('body').removeClass('view-grid view-list').addClass('view-' + view);
            }
        }

        function updateProductViewLabel(view) {
            const label = (view === 'list') ? 'List' : 'Grid';
            $('.facetwp-facet-view').closest('.filter-wrap').find('.value').text(label);
        }

        function applyCheckedClass(view) {
            $('.facetwp-facet-view .facetwp-checkbox').removeClass('checked');
            $('.facetwp-facet-view .facetwp-checkbox[data-value="' + view + '"]').addClass('checked');
        }

        // Initial load
        const initialView = getUrlParam('product_view') || 'grid';
        setViewClass(initialView);
        updateProductViewLabel(initialView);
        applyCheckedClass(initialView);

        // Toggle dropdowns
        $('.filter-label').on('click', function(e) {
            const $currentWrap = $(this).closest('.filter-wrap');

            // Close all other filter-wraps
            $('.filter-wrap').not($currentWrap).removeClass('open');

            // Toggle the current one
            $currentWrap.toggleClass('open');
        });
        // Handle product_view toggle manually
        $(document).on('click', '.facetwp-facet-view .facetwp-checkbox', function(e) {
            e.preventDefault();

            const view = $(this).data('value');

            // Update visual/UI state
            $('.facetwp-facet-view .facetwp-checkbox').removeClass('selected checked');
            $(this).addClass('selected checked');
            setViewClass(view);
            updateProductViewLabel(view);
            applyCheckedClass(view);

            // Update FacetWP manually to avoid duplicate params
            FWP.facets.product_view = [view];
            FWP.refresh();

            // Clean URL to just one param
            const url = new URL(window.location.href);
            url.searchParams.set('product_view', view);
            window.history.replaceState({}, '', url.toString());
        });

        // Handle all other checkbox facets
        $(document).on('click', '.facetwp-checkbox', function() {
            const $facet = $(this).closest('.facetwp-facet');
            const facetName = $facet.data('name');

            if (facetName === 'product_view') return;

            const $filterWrap = $facet.closest('.filter-wrap');
            const selected = [];

            $('.facetwp-facet-' + facetName + ' .facetwp-checkbox.selected .facetwp-display-value').each(function() {
                selected.push($(this).text());
            });

            if (selected.length > 0) {
                $filterWrap.find('.value').text(selected.join(', '));
            } else {
                const fallbackLabel = facetName === 'machine_type' ? 'Machinery Type'
                    : facetName === 'product_make' ? 'Make'
                        : 'Filter';
                $filterWrap.find('.value').text(fallbackLabel);
            }
        });

        // On FacetWP load: reset view UI
        $(document).on('facetwp-loaded', function() {
            const refreshedView = getUrlParam('product_view') || 'grid';
            setViewClass(refreshedView);
            updateProductViewLabel(refreshedView);
            applyCheckedClass(refreshedView);
        });

        // Close open filters when clicking outside
        $(document).on('click', function(e) {
            const $target = $(e.target);

            // If click is NOT on a checkbox or inside a filter-wrap
            if (
                !$target.closest('.filter-wrap').length ||
                ($target.is('body') && !$('.filter-wrap').has(e.target).length)
            ) {
                // If the clicked element isn't a checkbox or filter label
                if (!$target.hasClass('facetwp-checkbox') && !$target.hasClass('filter-label')) {
                    $('.filter-wrap').removeClass('open');
                }
            }
        });
    });







    jQuery(document).ready(function($) {
        $('.js-mobile-menu-trigger').on('click', function(e) {
            e.preventDefault();

            $(this).toggleClass('is-open'); // adds/removes class to button
            $('.mobile-menu').toggleClass('is-visible');
        });
    });





});

// debounce helper
function debounce(fn, delay) {
    let timer;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(context, args), delay);
    };
}

window.addEventListener('resize', debounce(function() {
    // reinit sliders on resize
    initHeroSlider();
    initProductSlider();
    initBrandsSlider();
    initSingleProductSlider();
    initFreeScrollSlider();

    // re-trigger AOS refresh
    AOS.refresh();
}, 250));